import { useGetEntitiesSuspense } from "api/generated/entities/entities";

type ISOTimestamp = string;

export function useRiskEntitiesQuery(at?: ISOTimestamp) {
    return useGetEntitiesSuspense(
        { at },
        { query: { select: (response) => response.data } }
    );
}
